module.exports = __webpack_public_path__ + "media/store/images/icon-buttons/size-66a1725e28973238eb70db5c59dc391d.svg";